import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/blade-system/role/list',
  method: 'get',
  meta: {
    doNotAddProjectId: true,
  },
  params: {
    ...params,
    current,
    size,
  },
})
export const grantTree = () => request({
  url: '/api/blade-system/menu/grant-tree',
  method: 'get',
})

export const grant = (roleIds, menuIds, dataScopeIds, apiScopeIds) => request({
  url: '/api/blade-system/role/grant',
  method: 'post',
  data: {
    roleIds,
    menuIds,
    dataScopeIds,
    apiScopeIds,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/role/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/role/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/role/submit',
  method: 'post',
  data: row,
})

export const getRole = roleIds => request({
  url: '/api/blade-system/menu/role-tree-keys',
  method: 'get',
  params: {
    roleIds,
  },
})

export const getRoleTree = tenantId => request({
  url: '/api/blade-system/role/tree',
  method: 'get',
  params: {
    tenantId,
  },
})

export const getBaseRoleTree = tenantId => request({
  url: '/api/blade-system/role/roleTree',
  method: 'get',
  params: {
    tenantId,
  },
})

export const getTenantList = tenantId => request({
  url: '/api/blade-system/tenant/select',
  method: 'get',
  params: {
    tenantId,
  },
})
